export default [{
  short: 'qd',
  name: '每日一次',
  num: 1
}, {
  short: 'bid',
  name: '每日两次',
  num: 2
}, {
  short: 'tid',
  name: '每日三次',
  num: 3
}, {
  short: 'qid',
  name: '每日四次',
  num: 4
}, {
  short: 'qod',
  name: '隔日一次',
  num: 0.5
}, {
  short: 'qw',
  name: '每周一次',
  num: 0.143
}, {
  short: 'biw',
  name: '每周两次',
  num: 0.286
}, {
  short: 'tiw',
  name: '每周三次',
  num: 0.429
}, {
  short: 'qow',
  name: '隔周一次',
  num: 0.071
}, {
  short: '2w',
  name: '每两周一次',
  num: 0.071
}, {
  short: '3w',
  name: '每三周一次',
  num: 0.048
}, {
  short: '4w',
  name: '每四周一次',
  num: 0.036
}, {
  short: 'q1/2h',
  name: '30分钟一次',
  num: 48
}, {
  short: 'qh',
  name: '每小时一次',
  num: 24
}, {
  short: 'q2h',
  name: '2小时一次',
  num: 12
}, {
  short: 'q3h',
  name: '3小时一次',
  num: 8
}, {
  short: 'q4h',
  name: '4小时一次',
  num: 6
}, {
  short: 'q6h',
  name: '6小时一次',
  num: 4
}, {
  short: 'q8h',
  name: '8小时一次',
  num: 3
}, {
  short: 'q12h',
  name: '12小时一次',
  num: 2
}, {
  short: 'qn',
  name: '每晚一次',
  num: 1
}, {
  short: 'hs',
  name: '临睡前',
  num: 1
}, {
  short: 'am',
  name: '上午',
  num: 1
}, {
  short: 'pm',
  name: '下午',
  num: 1
}]



// WEBPACK FOOTER //
// ./src/config/frequency.js